var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4004,
    cy: 27.8,
    r: 26.55,
    fill: "#D7E4FF",
    stroke: "#3276FF",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9156 41.1877C38.1692 41.1877 38.4125 41.0869 38.5918 40.9076C38.7711 40.7282 38.8719 40.485 38.8719 40.2314V28.0392C38.8719 27.6311 38.7915 27.227 38.6353 26.8499C38.4791 26.4729 38.2502 26.1303 37.9616 25.8417C37.673 25.5531 37.3304 25.3242 36.9534 25.168C36.5763 25.0118 36.1722 24.9314 35.7641 24.9314H33.1344V17.5205C33.1344 17.1123 33.054 16.7082 32.8978 16.3312C32.7416 15.9541 32.5127 15.6115 32.2241 15.3229C31.9355 15.0343 31.5929 14.8054 31.2159 14.6492C30.8388 14.493 30.4347 14.4127 30.0266 14.4127H18.7906C18.0298 14.4127 17.3001 14.7149 16.7621 15.2529C16.2241 15.7909 15.9219 16.5206 15.9219 17.2814V40.2314C15.9219 40.485 16.0226 40.7282 16.202 40.9076C16.3813 41.0869 16.6245 41.1877 16.8781 41.1877H37.9156Z",
    fill: "url(#paint0_linear_252_1420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.658 35.4502C33.0384 35.4502 33.4033 35.6013 33.6723 35.8703C33.9413 36.1393 34.0924 36.5042 34.0924 36.8846V41.1877H27.3986L26.4424 38.7971L27.3986 35.4502H32.658Z",
    fill: "url(#paint1_linear_252_1420)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1375 35.4501C21.7571 35.4501 21.3922 35.6013 21.1232 35.8703C20.8542 36.1393 20.7031 36.5041 20.7031 36.8845V41.1876H27.3969V35.4501H22.1375Z",
    fill: "url(#paint2_linear_252_1420)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1375 22.0627C22.5179 22.0627 22.8828 21.9115 23.1518 21.6425C23.4208 21.3735 23.5719 21.0087 23.5719 20.6283C23.5719 20.2479 23.4208 19.883 23.1518 19.614C22.8828 19.345 22.5179 19.1939 22.1375 19.1939C21.7571 19.1939 21.3922 19.345 21.1232 19.614C20.8542 19.883 20.7031 20.2479 20.7031 20.6283C20.7031 21.0087 20.8542 21.3735 21.1232 21.6425C21.3922 21.9115 21.7571 22.0627 22.1375 22.0627ZM22.1375 26.8439C22.5179 26.8439 22.8828 26.6928 23.1518 26.4238C23.4208 26.1548 23.5719 25.79 23.5719 25.4095C23.5719 25.0291 23.4208 24.6643 23.1518 24.3953C22.8828 24.1263 22.5179 23.9752 22.1375 23.9752C21.7571 23.9752 21.3922 24.1263 21.1232 24.3953C20.8542 24.6643 20.7031 25.0291 20.7031 25.4095C20.7031 25.79 20.8542 26.1548 21.1232 26.4238C21.3922 26.6928 21.7571 26.8439 22.1375 26.8439ZM23.5719 30.1908C23.5719 30.5712 23.4208 30.936 23.1518 31.205C22.8828 31.474 22.5179 31.6252 22.1375 31.6252C21.7571 31.6252 21.3922 31.474 21.1232 31.205C20.8542 30.936 20.7031 30.5712 20.7031 30.1908C20.7031 29.8104 20.8542 29.4455 21.1232 29.1765C21.3922 28.9075 21.7571 28.7564 22.1375 28.7564C22.5179 28.7564 22.8828 28.9075 23.1518 29.1765C23.4208 29.4455 23.5719 29.8104 23.5719 30.1908ZM26.9188 22.0627C27.2992 22.0627 27.664 21.9115 27.933 21.6425C28.202 21.3735 28.3531 21.0087 28.3531 20.6283C28.3531 20.2479 28.202 19.883 27.933 19.614C27.664 19.345 27.2992 19.1939 26.9188 19.1939C26.5383 19.1939 26.1735 19.345 25.9045 19.614C25.6355 19.883 25.4844 20.2479 25.4844 20.6283C25.4844 21.0087 25.6355 21.3735 25.9045 21.6425C26.1735 21.9115 26.5383 22.0627 26.9188 22.0627ZM28.3531 25.4095C28.3531 25.79 28.202 26.1548 27.933 26.4238C27.664 26.6928 27.2992 26.8439 26.9188 26.8439C26.5383 26.8439 26.1735 26.6928 25.9045 26.4238C25.6355 26.1548 25.4844 25.79 25.4844 25.4095C25.4844 25.0291 25.6355 24.6643 25.9045 24.3953C26.1735 24.1263 26.5383 23.9752 26.9188 23.9752C27.2992 23.9752 27.664 24.1263 27.933 24.3953C28.202 24.6643 28.3531 25.0291 28.3531 25.4095ZM26.9188 31.6252C27.2992 31.6252 27.664 31.474 27.933 31.205C28.202 30.936 28.3531 30.5712 28.3531 30.1908C28.3531 29.8104 28.202 29.4455 27.933 29.1765C27.664 28.9075 27.2992 28.7564 26.9188 28.7564C26.5383 28.7564 26.1735 28.9075 25.9045 29.1765C25.6355 29.4455 25.4844 29.8104 25.4844 30.1908C25.4844 30.5712 25.6355 30.936 25.9045 31.205C26.1735 31.474 26.5383 31.6252 26.9188 31.6252ZM33.1344 30.1908C33.1344 30.5712 32.9833 30.936 32.7143 31.205C32.4453 31.474 32.0804 31.6252 31.7 31.6252C31.3196 31.6252 30.9547 31.474 30.6857 31.205C30.4167 30.936 30.2656 30.5712 30.2656 30.1908C30.2656 29.8104 30.4167 29.4455 30.6857 29.1765C30.9547 28.9075 31.3196 28.7564 31.7 28.7564C32.0804 28.7564 32.4453 28.9075 32.7143 29.1765C32.9833 29.4455 33.1344 29.8104 33.1344 30.1908Z",
    fill: "url(#paint3_linear_252_1420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_1420",
    x1: 15.9219,
    y1: 15.2494,
    x2: 41.3648,
    y2: 43.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_1420",
    x1: 27.3986,
    y1: 34.4939,
    x2: 32.3224,
    y2: 40.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_1420",
    x1: 20.9422,
    y1: 36.7057,
    x2: 25.5618,
    y2: 41.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_1420",
    x1: 24.4325,
    y1: 17.8131,
    x2: 28.9737,
    y2: 34.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18);
export default __webpack_public_path__ + "static/media/Group 18.45247f1e950a270f538166c190ed8a21.svg";
export { ForwardRef as ReactComponent };